import { render, staticRenderFns } from "./AppealsForm.vue?vue&type=template&id=008f8e2c&scoped=true&"
import script from "./AppealsForm.vue?vue&type=script&lang=js&"
export * from "./AppealsForm.vue?vue&type=script&lang=js&"
import style0 from "./AppealsForm.vue?vue&type=style&index=0&id=008f8e2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008f8e2c",
  null
  
)

export default component.exports